import { LoadingButton } from '@mui/lab'
import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle'
import { yupResolver } from '@hookform/resolvers/yup'
import { ContactSchema } from './ContactValidation';
import AppTextInput from '../../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { VerificationAgencyContactsService } from '../../../../Component/Api/VerificationAgency/VerificationAgencyContacts/VerificationAgencyContactsService';
import { VerificationAgencyContacts } from '../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyContacts';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';


interface IContactsProps {
    showContactsModal: boolean;
    closeContactsModal: () => void;
    contactId?: number;
}
export const ContactsModal = ({ showContactsModal, closeContactsModal, contactId }: IContactsProps) => {
    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const { control, reset, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(ContactSchema)
    })

    const getContactDetails = async () => {
        const vaContact = await VerificationAgencyContactsService.GetById(contactId!);
        reset(vaContact.data)
    }
    useEffect(() => {
        if (contactId != null) {
            getContactDetails();
        }
    }, [contactId])

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            if (contactId == null){
                const dtoIn: VerificationAgencyContacts.VerificationAgencyContactRequest = {
                    contactFirstName: data.contactFirstName,
                    contactLastName: data.contactLastName,
                    contactEmail: data.contactEmail,
                    contactTelephone: data.contactTelephone,
                    contactPosition: data.contactPosition,
                    verificationAgencyContactId: 0,
                    vaClientId: verificationCompany.vaClientId
                }
                const result = await VerificationAgencyContactsService.CreateEntry(dtoIn);
                if (result.status === 200) {
                    toast.success('Contact Added');
                    closeContactsModal();
                }
            }
            if (contactId != null){
                const result = await VerificationAgencyContactsService.UpdateEntry(data as VerificationAgencyContacts.VerificationAgencyContactResponse);
                if (result.status === 200) {
                    toast.success('Contact Updated');
                    closeContactsModal();
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <Box>
            <Dialog disableEnforceFocus open={showContactsModal} onClose={() => { closeContactsModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
                <CustomDialogTitle id="employee-dialog-title" onClose={() => closeContactsModal()}>
                    {contactId == null ? 'Add Contact' : 'Edit Contact'}
                </CustomDialogTitle>
                <DialogContent>
                    <form id='EmployeeForm' onSubmit={handleSubmit(handleDataSubmit)}>
                        <Grid container spacing={1} mt={1}>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name="contactFirstName" label="Name" />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name="contactLastName" label="Surname" />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name="contactEmail" label="Email" />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name="contactTelephone" label="Telephone Number" />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <AppTextInput control={control} name="contactPosition" label="Position" />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={isSubmitting} variant='contained' form='EmployeeForm' type="submit" color='primary'>
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>

        </Box>
    )
}

